import { useState } from "react";
import { NumberInput } from "../fields/NumberInput";

interface OverrideMultiplierInputProps {
  value: number;
  disabled: boolean;
  onPreview: (multiplier: number) => void;
  onCommit: (multiplier: number) => Promise<boolean>;
  children?: never;
}

/** UW Override Multiplier: recomputes Adjusted RMM live, persists on blur. */
export function OverrideMultiplierInput({ value, disabled, onPreview, onCommit }: OverrideMultiplierInputProps) {
  const [committed, setCommitted] = useState(value);
  const [current, setCurrent] = useState<number | null>(value);

  if (value !== committed) {
    setCommitted(value);
    setCurrent(value);
  }

  const handleChange = (next: number | null) => {
    setCurrent(next);
    if (next !== null && next >= 0) onPreview(next);
  };

  const handleBlur = async () => {
    const next = current === null || current < 0 ? 1 : current;
    setCurrent(next);
    if (next === committed) {
      onPreview(next);
      return;
    }
    const saved = await onCommit(next);
    if (saved) setCommitted(next);
    else {
      setCurrent(committed);
      onPreview(committed);
    }
  };

  return <NumberInput id="override-multiplier" label="UW Override Multiplier" value={current} onChange={handleChange} onBlur={() => void handleBlur()} min={0} step={0.01} allowDecimal readOnly={disabled} isOverridden={committed !== 1} size="sm" />;
}
